import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../redux/actions/authActions";
import SuccessPopup from "../../popups/SuccessPopup";
import ErrorPopup from "../../popups/ErrorPopup";
import SidebarIconItem from "./sidebarIconItem";
import LogoutModal from "../../modals/logoutModal";
import More from "../../../assets/icons/sidebar/more";
import moreUp from "../../../assets/icons/moreUp.svg";
import moreDown from "../../../assets/icons/moreDown.svg";
import faq from "../../../assets/faq.svg";
import support from "../../../assets/life-ring.svg";
import userLogo from "../../../assets/userProfile.svg";
import logoutLogo from "../../../assets/signOut.svg";
import { AnimatePresence, motion } from "framer-motion";

const SidebarIconComponent = ({
  userPermissionList,
  sidebarConfig,
  setOpen,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const userType = localStorage.getItem("userType");

  const [logoutShow, setLogoutShow] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState();
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState();
  const [moreOptions, setMoreOptions] = useState(false);
  const [userData, setUserData] = useState(null);
  const handleLogoutShow = () => setLogoutShow(true);
  const componentRef = useRef(null);

  useEffect(() => {
    if (userType === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      setUserData(permissionData?.map((item) => item?.module_name));
    }
  }, []);

  const activePath = "/" + location.pathname.split("/")[1];
  const activeSubPath = "/" + location.pathname.split("/")[2];

  const logoutHandler = () => {
    dispatch(logout(logoutSuccess, logoutError));
  };

  const logoutSuccess = (data) => {
    setShowSuccessMsg(capitalize(data.data.message));
    setShowSuccessPopup(true);
    setTimeout(() => navigate("/"), 2000);
  };

  const logoutError = (err) => {
    console.log(err);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
  };

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        componentRef.current &&
        !componentRef.current.contains(event.target)
      ) {
        setMoreOptions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="d-none d-lg-block" style={{ height: "88vh" }}>
      <div className="d-flex flex-column justify-content-start align-items-between h-100 w-100">
        <div
          className="d-flex flex-column justify-content-center align-itmes-center py-4 text-uppercase h-100"
          onClick={() => setOpen(false)}
        >
          <ul className="nav-options w-100 h-100 d-flex flex-column justify-content-between align-items-center">
            <div className="w-100 d-flex flex-column justify-content-between align-items-center main position-relative">
              {sidebarConfig.map((item) =>
                typeof item.visible === "function"
                  ? item.visible({ userType, userPermissionList }) && (
                      <SidebarIconItem
                        key={item.label}
                        item={item}
                        activePath={activePath}
                        activeSubPath={activeSubPath}
                        navigate={navigate}
                      />
                    )
                  : null
              )}
            </div>
            <div className="position-relative" ref={componentRef}>
              <div
                className={`p-1 d-flex align-items-center justify-content-between ${
                  moreOptions ? "nav-items-active2" : "nav-items"
                }`}
                onClick={() => {
                  setMoreOptions(!moreOptions);
                }}
              >
                <div>
                  <More
                    fill={moreOptions ? "#7065e4" : "#747F9E"}
                    height="18px"
                    width="18px"
                  />
                </div>
              </div>

              <AnimatePresence>
                {moreOptions && (
                  <motion.div
                    style={{ width: "240px" }}
                    className="more-popup-container p-1"
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 0, opacity: 0 }}
                  >
                    {userType !== "super_user" && (
                      <li
                        className={`nav-items d-flex justify-content-start align-items-center p-1 ${
                          activePath === "/faq" ? "nav-items-active" : ""
                        }`}
                        onClick={() => navigate("/faq")}
                      >
                        <img src={faq} />
                        <span className="nav-text-2">FAQ's</span>
                      </li>
                    )}

                    {(userType !== "super_user" ||
                      (userType === "super_user" &&
                        userData?.includes("Support"))) && (
                      <li
                        className={`nav-items d-flex justify-content-start align-items-center p-1 ${
                          activePath === "/contact-support"
                            ? "nav-items-active"
                            : ""
                        }`}
                        onClick={() => navigate("/contact-support")}
                      >
                        <img src={support} />
                        <span className="nav-text-2">Contact Support</span>
                      </li>
                    )}

                    <li
                      className="nav-items d-flex justify-content-start align-items-center p-1"
                      onClick={handleLogoutShow}
                    >
                      <img src={userLogo} />
                      <div className="logout-div">
                        <span className="nav-text-2">Logout</span>
                        <img src={logoutLogo} />
                      </div>
                    </li>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          </ul>
        </div>
        <LogoutModal
          logoutShow={logoutShow}
          handleLogoutClose={() => setLogoutShow(false)}
          logoutFunc={logoutHandler}
        />
      </div>
      <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </div>
  );
};
export default SidebarIconComponent;
